var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Container, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import Loader from "../components/Loader";
import VideoSafeContent from "../components/VideoSafeContent";
import { getSiteContent } from "../utils/api/sitecontent/dataAccess";
const Help = () => {
    const [loading, setLoading] = useState(true);
    const [selectedPage, setSelectedPage] = useState();
    useEffect(() => {
        const fetchContent = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const apiResponse = yield getSiteContent(undefined, "Help");
                const selectedContent = apiResponse.data[0];
                setSelectedPage(selectedContent);
            }
            catch (error) {
                console.error("Error fetching site content:", error);
            }
            finally {
                setLoading(false);
            }
        });
        fetchContent();
    }, []);
    return (React.createElement(Container, { maxWidth: false, sx: { width: "100%" } },
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { item: true, xs: 12 }, loading ? (React.createElement(Loader, null)) : (React.createElement(VideoSafeContent, { htmlContent: (selectedPage === null || selectedPage === void 0 ? void 0 : selectedPage.htmlContent) || "" }))))));
};
export default Help;
